<template>
    <div class="popup">
        <van-popup
            v-model="popupStop"
            position="center"
            :close-on-click-overlay='false'
        >
            <div class="dig">
                <div class="body">
                    <div class="img"><img src="../../../assets/img/b2b/icon_disable_64@2x.png" alt=""></div>
                    <div class="title">禁用提示</div>
                    <div class="content">会员店已被禁用，请联系平台运营人员！</div>
                </div>
                <div class="ft" @click="onHide">
                    好的
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    name: 'popup',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupStop: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onHide () {
            this.$emit('update:visible')
        }
    }
}
</script>
<style lang="scss" scoped>
.dig{
    background: #ffffff;
    width: 590px;
    margin: 0 auto;
    border-radius: 12px;
    .body{
        text-align: center;
        color: #333333;
        padding: 56px 56px 0;
        .img{
            width: 128px;
            height: 128px;
            margin: 0 auto;
        }
        .title{
            font-size: 34px;
            margin-top: 56px;
            margin-bottom: 32px;
        }
        .content{
            font-size: 30px;
            margin-bottom: 48px;
        }
    }
    .ft{
        font-size: 32px;
        color: #FF7A45;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-top: 2px solid #f5f5f5;
    }
}
/deep/ .van-popup{
    background: none
}
</style>